module.exports = __webpack_public_path__ + "static/img/27.d7d4227.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/background/27.jpg
// module id = wXwr
// module chunks = 0